<template>
    <div class=" questionPracticeNotes">
        <div>
            <div>
                <div style="min-height: 60px;background: #ffffff;" class="padding-b-x position-relative">
                    <div class="  border-bottom titleOut">
                        练习记录
                    </div>
                    <div class="optionList " v-show="!loadingTj&&subjectList.length>0">
                        <span class="margin-right title">学科:</span>
                        <span @click="selectSubject(item.subjectId)" v-for="item in subjectList" class="rounded-mini margin-right cursorSz subjectOp " :class="subjectId===item.subjectId?'activelvz':''"  :key="item.subjectId">
                            {{item.subjectName}}
                        </span>
                    </div>
                </div>
                <div class="contentBox position-relative">
                    <div  v-show="!loadingData&&answerList.length>0">
                        <ul class="smallBox">
                            <li v-for="(item,index) in answerList" :key="index" class="float-left cursorSz" @click="jumpSearchAnswer(item.paperId)" >
                                <div class="sonBox">
                                    <img src="../../../assets/img/练习记录.png" height="42" width="42"/>
                                </div>
                                <div class="sonBox padding-x">
                                    <div class="title text-ellipsis text-default-color" :content="item.paperName">
                                        {{item.paperName}}
                                    </div>
                                    <div>
                                        <span class="time">{{item.createdAt}}</span>
                                    </div>
                                </div>
                                <div class="sonBox">
                                    <div class="circleBox">
                                        <el-progress :show-text="false" status="success" :width="70" type="circle" :percentage="item.accuracy"></el-progress>
                                        <div class="circleCenter">
                                            <div>正确率 </div>
                                            <div>
                                                {{item.accuracy+'%'}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <div class="fy position-absolute text-center w-100 ">
                                <el-pagination
                                        class="m-auto"
                                        @current-change="handleCurrentChange"
                                        :current-page.sync="currentPage"
                                        :page-size="10"
                                        layout="prev, pager, next, jumper"
                                        :total="totalItem">
                                </el-pagination>
                            </div>
                        </ul>
                    </div>
                    <empty v-show="!loadingData&&answerList.length<1" :text-size="16" :widths="150" :heights="150" class="margin-top"></empty>
                    <loading :show="loadingData" ></loading>
                </div>
            </div>
        </div>
        <common-target-router @clearHref="clearHref" :get-location="getLocation" ></common-target-router>
    </div>
</template>

<script>
    import {questionBankFavSubjects, questionBankLogs} from "../../../config";

    export default {
        name: "questionPracticeNotes",
        data(){
            return{
                subjectList:[],
                subjectId:'',
                loadingData:false,
                answerList:[],
                currentPage:1,
                //条件加载
                loadingTj:false,
                totalItem:0,
                getLocation:''
            }
        },
        mounted(){
          this.searchSubjectList();
        },
        methods:{
            async jumpSearchAnswer(val){
                const {href}=this.$router.resolve({path:'/onLineABegin',query:{paperId:val}});
                this.getLocation=href;
            },
            clearHref(){
                this.getLocation='';
            },
            handleCurrentChange(){
                this.searchAnswerNoteList();
            },
            //查出我的学科列表
            async searchSubjectList(){
                this.loadingTj=true;
                let result=await questionBankFavSubjects();
                if(result.status){
                    this.loadingTj=false;
                    this.subjectList=result.data;
                    this.subjectId=result.data[0].subjectId;
                    console.log(result.data);
                    this.searchAnswerNoteList();
                }else{
                    this.loadingTj=false;
                }
            },
            //选择学科
            selectSubject(val){
                this.currentPage=1;
                this.subjectId=val;
                this.searchAnswerNoteList();
            },
            //查出答题记录
            async searchAnswerNoteList(){
                this.loadingData=true;
                let result=await questionBankLogs(this.subjectId,this.currentPage,10);
                if(result.status){
                    this.loadingData=false;
                    console.log('我是答题记录页面');
                    console.log(result.data);
                    this.answerList=result.data.data;
                    this.totalItem=result.data.totalRecords;

                }else{
                    this.loadingData=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .questionPracticeNotes{
        margin:10px 0 0 0;
        .titleOut{
            font-size:16px;
            color:#2779FF;
            font-weight: bold;
            padding-top: 15px;
            margin-bottom: 15px;
        }
        .titleOut:after{
            display: block;
            content:" ";
            background:#2779FF;
            height:2px;
            border-radius:2px;
            width: 50px;
            margin:10px 0 0 5px;
        }
        .optionList{

            .title{
                font-weight: bolder;
            }
            span{
                font-size:1.1em;
            }
        }
        .contentBox{
            min-height: 300px;
            height: auto;
            display: block;
            .smallBox{
                min-height:600px;
                width: 100%;
                .fy{
                    margin: 30px auto 30px auto;
                    bottom: 0;

                }
                li:hover{
                    animation:commOptionBox .4s ease-out forwards;
                }
                li{
                    position: relative;
                    padding-left: 30px;
                    margin-top: 20px;
                    width: 590px;
                    background: #fff;
                    float: left;
                    border-radius: 6px;
                    height: 100px;
                    .sonBox{
                        float: left;
                    }
                    .sonBox:nth-child(1){

                        margin-top: 30px;
                        width:42px;
                        height:42px;

                    }
                    .sonBox:nth-child(2){
                        margin-left: 20px;
                        width: 390px;
                        height:100px;

                        .title{
                            font-size: 16px;
                            margin-bottom: 20px;
                            padding-top: 18px;
                        }
                        .time{
                            color: #9a9a9a;
                        }
                    }
                    .sonBox:nth-child(3){
                        margin-top: 15px;
                        .circleBox{
                            position: relative;
                            text-align: center;
                            width: 70px;
                            .circleCenter{
                                position: absolute;
                                top: 17px;
                                left:17px;
                                color:#61b261;
                                div{
                                    font-weight: bolder;
                                }
                            }
                        }
                    }
                }
                li {
                    margin-left: 19px;
                }

            }
        }
        .subjectOp{
            display: inline-block;
            line-height: 1.8em;
            height: 1.8em;
            padding-left: 1.2em ;
            padding-right: 1.2em ;
        }
        .subjectOp:hover{
            animation: commonOption .3s ease-out forwards;
        }

    }
</style>